export const NOTIFICATION = {
    GET_NOTIFICATION: 'notification/GET_NOTIFICATION', 
    READ_NOTIFICATION: 'notification/READ_NOTIFICATION'
};